import { api } from "..";

import { NewUser } from "@/types/ApiResponses/User";

export interface CreateAgentPayload {
  username: string;
  password: string;
  balance: number;
  bettingRulesLocked?: boolean;
}

export async function createAgent(
  payload: CreateAgentPayload
): Promise<NewUser> {
  const res = await api.client.post("/agents-new", payload);
  return res.data;
}
